var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarnAlert(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9177 4.74094L2.44771 18.8809C2.27307 19.1834 2.18067 19.5262 2.1797 19.8755C2.17872 20.2247 2.2692 20.5681 2.44213 20.8715C2.61507 21.1749 2.86443 21.4277 3.16541 21.6048C3.4664 21.7819 3.80851 21.8771 4.15771 21.8809H21.0977C21.4469 21.8771 21.789 21.7819 22.09 21.6048C22.391 21.4277 22.6403 21.1749 22.8133 20.8715C22.9862 20.5681 23.0767 20.2247 23.0757 19.8755C23.0747 19.5262 22.9823 19.1834 22.8077 18.8809L14.3377 4.74094C14.1594 4.44705 13.9084 4.20406 13.6089 4.03543C13.3094 3.86679 12.9714 3.7782 12.6277 3.7782C12.284 3.7782 11.946 3.86679 11.6465 4.03543C11.347 4.20406 11.096 4.44705 10.9177 4.74094V4.74094Z",
    stroke: "#F3A549",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6279 9.88098V13.881",
    stroke: "#F3A549",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6279 17.881H12.6379",
    stroke: "#F3A549",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.62793 0.880981)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarnAlert);
export default __webpack_public_path__ + "static/media/warn_alert.97ee9db1d831bf26d86b5199c9ad85d7.svg";
export { ForwardRef as ReactComponent };